<template>
    <div class="h-screen flex flex-col justify-center w-full bg-img" v-if="loaded">
      <div class="mb-base">
        <h1 class="text-center">Pilih Perusahaan</h1>
        <p class="text-center">Silakan pilih satu perusahaan untuk mengakses Accounting dan Cashflow</p>
      </div>
      <div class="flex items-center justify-center mt-base">
        <template v-for="data in companiesData">
          <vx-card :key="data.id" class="flex justify-center mx-4 lg:w-1/5">
              <!-- <skeleton-loader-vue
                type="rect"
                :width="200"
                :height="200"
                rounded=true
                radius= "8"
                animation="fade"
              /> -->
              <img :src="require('@/assets/images/pages/content-img-3.jpg')" alt="content-img" class="responsive rounded-lg">
              <div class="my-4">
                  <h6 class="mb-2">{{data.name}}</h6>
                  <p class="text-grey">{{data.npwp}}</p>
              </div>
              <div class="flex justify-between flex-wrap">
                  <vs-button @click="access(data)" class="w-full mt-4 mr-2 shadow-lg">Akses</vs-button>
              </div>
          </vx-card>
        </template>
      </div>
    </div>
</template>

<script>
// Store Module
import moduleCompanies from '@/store/companies/moduleCompanies.js'

import VueSkeletonLoader from 'skeleton-loader-vue'

export default{
  components: {
    'skeleton-loader-vue' : VueSkeletonLoader
  },
  data () {
    return {
      loaded: false,
      companiesData: []
    }
  },
  methods: {
    loading () {
      this.loaded = false
      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Wait a minute, It\'s getting data.'
      })
    },
    onLoaded () {
      this.loaded = true
      this.$vs.loading.close()
    },
    access (data) {
      localStorage.setItem('activeCompany', JSON.stringify(data))
      this.$router.push('/dashboard')
    },
    getCompanies () {
      const self        = this

      this.$store.dispatch('companies/fetchUserCompanies')
        .then(res => {

          res.data.data.forEach((value) => {
            self.companiesData.push({
              id    : value.id,
              name  : value.name,
              npwp  : value.npwp
            })
          })

        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
        .finally(() => {
          this.onLoaded()
        })
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  created () {
    // Register Module Companies Module
    if (!moduleCompanies.isRegistered) {
      this.$store.registerModule('companies', moduleCompanies)
      moduleCompanies.isRegistered = true
    }
    this.loading()
    this.getCompanies()
  }
}
</script>

